<!--Modals-->
<app-common-bulk-select-employee-dialog #appEmployeeSelection [label]="'time-off-v3.assign' | translate">
</app-common-bulk-select-employee-dialog>

<app-deprecated-modal-form
    [stubby]="true"
    headerText="{{ 'time-off-v3.createWorkSchedule' | translate }}"
    [form]="workScheduleForm"
    #createWorkScheduleDialog
    (save)="createWorkScheduleAndRedirect(workScheduleForm.workSchedule)"
>
    <app-work-schedule-form #workScheduleForm></app-work-schedule-form>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    [stubby]="true"
    headerText="{{ 'time-off-v3.createTimeOffApprovalFlow' | translate }}"
    [form]="approvalFlowForm"
    #createApprovalFlowDialog
    (save)="createApprovalFlowAndRedirect(approvalFlowForm.timeOffApprovalFlow)"
>
    <app-approval-flow-form #approvalFlowForm></app-approval-flow-form>
</app-deprecated-modal-form>
<app-deprecated-modal-form
    [stubby]="true"
    label="{{ 'time-off-v3.assign' | translate }}"
    headerText="{{ 'time-off-v3.assignApprovalFlow' | translate }}"
    [form]="assignApprovalFlowForm"
    #assignApprovalFlowDialog
    (save)="onAssignApprovalFlows()"
>
    <app-assign-approval-flow-form #assignApprovalFlowForm></app-assign-approval-flow-form>
</app-deprecated-modal-form>

<app-deprecated-confirmation-dialog
    #workScheduleDeleteModal
    header="{{ 'time-off-v3.deleteWorkSchedule' | translate }}"
    description="{{ 'time-off-v3.areYouSureYouWantToDeleteThisWorkSchedule' | translate }}"
    label="{{ 'time-off-v3.delete' | translate }}"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<app-deprecated-confirmation-dialog
    #approvalFlowDeleteModal
    header="{{ 'time-off-v3.deleteApprovalFlow' | translate }}"
    description="{{ 'time-off-v3.areYouSureYouWantToDeleteThisApprovalFlow' | translate }}"
    label="{{ 'time-off-v3.delete' | translate }}"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<app-deprecated-confirmation-dialog
    #deleteTypeModal
    header="time-off-v3.deleteTimeOffType"
    label="time-off-v3.delete"
    [negative]="true"
    [useNgContent]="true"
>
    <b>{{ 'time-off-v3.areYouSureYouWantToDeleteThisTimeOffType' | translate }}</b>
    <p>{{ 'time-off-v3.thisWillIrreversiblyDeleteAllRequestsPolicies' | translate }}</p>
</app-deprecated-confirmation-dialog>

<!--View-->
<div class="page-container loadable" [class.loading]="isLoading">
    <app-header title="{{ 'time-off-v3.settings' | translate }}" [menuService]="timeOffModuleMenuService"></app-header>

    <ng-container *ngIf="isTimeOffImprovementsFeatureFlagEnabled">
        <!-- General Settings -->
        <app-general-settings-card
            [timeOffVisibility]="timeOffVisibility"
            [timeOffBalanceDateToday]="timeOffBalanceDateToday"
        ></app-general-settings-card>
    </ng-container>

    <ng-container *ngIf="!isTimeOffImprovementsFeatureFlagEnabled">
        <!-- Overall Settings -->
        <div class="ui segment">
            <app-segment-header title="{{ 'time-off-v3.overallSettings' | translate }}"> </app-segment-header>
            <div class="flex middle margin-bottom-3 margin-top-6">
                <mat-slide-toggle name="slideToggle" color="primary" [(ngModel)]="timeOffVisibility"
                    >{{ 'time-off-v3.timeOffLeaveVisibility' | translate }}
                </mat-slide-toggle>
                <ui-info [text]="settingsToolTips.timeOffLeaveVisibility | appTranslate"></ui-info>
            </div>
            <div class="margin-top-4">
                <label>{{ 'time-off-v3.profileBalanceDisplayDate' | translate }}</label>
                <ui-info class="margin-left-1" [text]="settingsToolTips.timeOffBalanceDate | appTranslate"></ui-info>
                <div class="flex align-items-baseline margin-top-1">
                    <mat-radio-group class="margin-right-2" [(ngModel)]="timeOffBalanceDateToday">
                        <mat-radio-button [value]="true">{{ 'time-off-v3.today' | translate }}</mat-radio-button>
                        <mat-radio-button [value]="false">
                            {{
                                'time-off-v3.policyComponents.settings.general-settings.yearEndHasTimeOffBalance'
                                    | translate
                            }}</mat-radio-button
                        >
                    </mat-radio-group>
                </div>
            </div>
            <div class="margin-top-4">
                <label>{{ 'time-off-v3.setABackupApproverForWhen' | translate }}</label>
                <div class="align-items-baseline margin-top-1 app-grid">
                    <mat-form-field class="columns-2 small-columns-3 no-labels no-helpers">
                        <mat-select
                            [ngModel]="selectedBackupApprover"
                            name="timeOffBackupApprover"
                            #timeOffBackupApprover
                            placeholder="{{ 'time-off-v3.allActiveAdmins' | translate }}"
                            (selectionChange)="onUpdateBackupApprover($event)"
                            required
                        >
                            <mat-option [value]="0">{{ 'time-off-v3.allActiveAdmins' | translate }}</mat-option>
                            <mat-option [value]="admin.id" *ngFor="let admin of activeAdmins">
                                {{ admin.fullName }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <a
                        href="https://humi.zendesk.com/hc/en-us/articles/4411058160151"
                        class="columns-3 small-columns-6"
                        (click)="trackLearnMoreBackupApprover()"
                        target="_blank"
                        >{{ 'time-off-v3.learnMoreAboutBackupApprovers' | translate }}
                    </a>
                </div>
            </div>
        </div>
    </ng-container>

    <!-- Time Off Types -->
    <ui-card *ngIf="isTimeOffImprovementsFeatureFlagEnabled" [withSpacing]="false">
        <app-table
            title="{{ 'time-off-v3.timeOffTypesTable.title' | translate }}"
            subTitle="{{ 'time-off-v3.timeOffTypesTable.subTitle' | translate }}"
            [useStickyHeader]="false"
            [showSearch]="false"
            [table]="timeOffTypesTable"
            (menuItemSelected)="menuAction($event)"
            [isResponsive]="true"
            [embedded]="true"
            [noPadding]="true"
        >
            <app-empty-state
                label="time-off-v3.timeOffTypesTable.noTimeOffTypes"
                src="/assets/illustrations/empty-box.png"
            ></app-empty-state>
            <div class="buttons">
                <ui-button type="outline" (click)="onCreateTimeOffTypeClick()"
                    ><mat-icon svgIcon="plus"></mat-icon
                    >{{ 'time-off-v3.timeOffTypesTable.createTimeOffTypeButton' | translate }}</ui-button
                >
            </div>
        </app-table>
    </ui-card>

    <!-- Work Schedules -->
    <ui-card [withSpacing]="false">
        <app-table
            [attr.data-cy]="'work-schedule'"
            title="{{
                (isTimeOffImprovementsFeatureFlagEnabled
                    ? 'time-off-v3.policyComponents.workSchedules.header'
                    : 'time-off-v3.workSchedulesStatHolidaysWeekendsBlackouts'
                ) | translate
            }} "
            subTitle="{{
                (isTimeOffImprovementsFeatureFlagEnabled ? 'time-off-v3.policyComponents.workSchedules.subTitle' : '')
                    | translate
            }} "
            [useStickyHeader]="false"
            [showSearch]="false"
            [table]="workScheduleTable"
            (menuItemSelected)="menuAction($event)"
            [showPagination]="false"
            [isResponsive]="true"
            [embedded]="true"
            [noPadding]="true"
        >
            <app-empty-state
                label="time-off-v3.noWorkScheduleHasBeenAddedYet"
                src="/assets/illustrations/empty-box.png"
            ></app-empty-state>
            <div class="buttons">
                <ui-button type="outline" (click)="onCreateWorkScheduleClick()"
                    ><mat-icon svgIcon="plus"></mat-icon>{{ 'time-off-v3.createWorkSchedule' | translate }}</ui-button
                >
            </div>
        </app-table>
    </ui-card>

    <!-- Approval Flow -->
    <ui-card [withSpacing]="false">
        <app-table
            title="{{ 'time-off-v3.approvalFlows' | translate }}"
            subTitle="{{
                (isTimeOffImprovementsFeatureFlagEnabled ? 'time-off-v3.approvalFlowSubtitle' : '') | translate
            }}"
            [useStickyHeader]="false"
            [showSearch]="false"
            [table]="timeOffApprovalFlowTable"
            (menuItemSelected)="menuAction($event)"
            [showPagination]="false"
            [isResponsive]="true"
            [embedded]="true"
            [noPadding]="true"
        >
            <app-empty-state
                label="time-off-v3.noApprovalFlowHasBeenAddedYet"
                src="/assets/illustrations/empty-box.png"
            ></app-empty-state>
            <div class="buttons">
                <ui-button type="outline" (click)="onCreateApprovalFlowClick()"
                    ><mat-icon svgIcon="plus"></mat-icon>{{ 'time-off-v3.createApprovalFlow' | translate }}</ui-button
                >
            </div>
        </app-table>
    </ui-card>

    <ng-container *ngIf="isTimeOffImprovementsFeatureFlagEnabled">
        <app-import-time-off-data-card></app-import-time-off-data-card>
    </ng-container>
</div>
